// Propinas: puestos (User.position) y reglas de reparto (cashbox.TipConfig).
export const POSITIONS = [
  { key: "MESERO", value: "MESERO", text: "Mesero" },
  { key: "COCINA", value: "COCINA", text: "Cocina" },
  { key: "BAR", value: "BAR", text: "Bar" },
  { key: "CAJA", value: "CAJA", text: "Caja" },
  { key: "OTRO", value: "OTRO", text: "Otro" },
];

export const positionText = (value) => POSITIONS.find((p) => p.value === value)?.text || "Sin puesto";

export const TIP_MODELS = [
  { key: "INDIVIDUAL", value: "INDIVIDUAL", text: "Individual (cada mesero lo de sus mesas)" },
  { key: "POOL", value: "POOL", text: "Pozo equitativo (partes iguales)" },
  { key: "POINTS", value: "POINTS", text: "Puntos por puesto (recomendado)" },
  { key: "PERCENT", value: "PERCENT", text: "Porcentaje por puesto" },
];

export const tipModelText = (value) =>
  (TIP_MODELS.find((m) => m.value === value)?.text || value).replace(" (recomendado)", "");

export const POINTS_HINT =
  "Recomendado si tienes más meseros que personal de soporte, evita la dilución del ingreso en salón";

export const CARD_PAYOUTS = [
  { key: "DRAWER", value: "DRAWER", text: "En efectivo desde la caja al liquidar" },
  { key: "PAYABLE", value: "PAYABLE", text: "Queda por pagar (transferencia o planilla)" },
];
